import { useEffect } from 'react';
import HeroSection from './components/HeroSection';
import ReelSection from './components/ReelSection';
import FeaturedWork from './components/FeaturedWork';
import ServicesSection from './components/ServicesSection';
import ContactSection from './components/ContactSection';

const SITE_URL = import.meta.env.VITE_SITE_URL ?? 'https://example.com';

const schemaData = [
  {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: 'Anna Schriver',
    url: SITE_URL,
    jobTitle: 'Filmmaker, Video Editor & Creative Director',
    description:
      'Anna Schriver is a freelance filmmaker, video editor, and creative director crafting cinematic video content for brands, athletes, and creators. Based in Colorado.',
    sameAs: ['https://www.instagram.com/anna_schriver/'],
    knowsAbout: ['Filmmaking', 'Video Editing', 'Creative Direction', 'Motion Design', 'Video Production', 'Sports Content', 'Brand Films'],
    address: {
      '@type': 'PostalAddress',
      addressRegion: 'CO',
      addressCountry: 'US',
    },
    alumniOf: {
      '@type': 'CollegeOrUniversity',
      name: 'University of Colorado Boulder',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Anna Schriver',
    url: SITE_URL,
    description: 'Portfolio of Anna Schriver — freelance filmmaker, video editor, and creative director based in Colorado.',
    author: {
      '@type': 'Person',
      name: 'Anna Schriver',
    },
    potentialAction: {
      '@type': 'SearchAction',
      target: `${SITE_URL}/projects`,
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'CreativeWork',
    name: 'Anna Schriver — Demo Reel',
    description: 'Official demo reel showcasing filmmaking, video editing, and creative direction work by Anna Schriver.',
    creator: {
      '@type': 'Person',
      name: 'Anna Schriver',
      url: SITE_URL,
    },
    url: SITE_URL,
    genre: ['Filmmaking', 'Video Editing', 'Sports Content', 'Brand Films'],
    locationCreated: {
      '@type': 'Place',
      address: {
        '@type': 'PostalAddress',
        addressRegion: 'CO',
        addressCountry: 'US',
      },
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'ProfessionalService',
    name: 'Anna Schriver — Freelance Filmmaker & Video Editor',
    description: 'Freelance filmmaking, video editing, and creative direction services for brands, athletes, and creators. Based in Colorado.',
    url: SITE_URL,
    provider: {
      '@type': 'Person',
      name: 'Anna Schriver',
    },
    areaServed: {
      '@type': 'State',
      name: 'Colorado',
    },
    serviceType: ['Filmmaking', 'Video Editing', 'Creative Direction', 'Brand Films', 'Sports Content'],
    sameAs: ['https://www.instagram.com/anna_schriver/'],
  },
];

export default function HomePage() {
  useEffect(() => {
    const id = 'schema-home';
    let el = document.getElementById(id) as HTMLScriptElement | null;
    if (!el) {
      el = document.createElement('script');
      el.id = id;
      el.type = 'application/ld+json';
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(schemaData);
    document.title = 'Anna Schriver - Filmmaker, Video Editor & Creative Director';
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute('content', 'Anna Schriver is a freelance filmmaker, video editor, and creative director crafting cinematic video content for brands, athletes, and creators. Based in Colorado.');
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', `${SITE_URL}/`);
    return () => {
      document.getElementById(id)?.remove();
    };
  }, []);

  return (
    <div className="min-h-screen" style={{ background: '#0d0d0f' }}>
      <HeroSection />
      <ReelSection />
      <FeaturedWork />
      <ServicesSection />
      <ContactSection />
    </div>
  );
}
